import uniqid from 'uniqid';
import { Cafe, Order, OrderItem, OrderLog, OrderStatus, Order as OrderType } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  id: string;
  cafeSlug: string;
  workerId: string;
  workerName: string;
  cafe: DbDocument<Cafe>;
  tableId: string | null;
  tableName: string;
  delivery: Order['delivery'];
  status: OrderStatus;
  type: OrderType['type'];
  items?: Record<string, OrderItem>;
  clientName: string;
  clientId: string;
  discount: number;
  selfOrderPointId?: string | null;
};

export const createOrder = async ({
  id,
  workerId,
  workerName,
  cafe,
  cafeSlug,
  tableId,
  tableName,
  delivery,
  status,
  type,
  clientName,
  clientId,
  discount,
  items = {},
  selfOrderPointId,
}: Props) => {
  if (cafe) {
    const orderNumber = cafe.lastOrderNumber + 1;
    const batch = createBatch();

    batch.update<Cafe>(`cafes/${cafeSlug}`, { lastOrderNumber: orderNumber });

    batch.set<OrderType>(`cafes/${cafeSlug}/orders/${id}`, {
      number: orderNumber,
      created: Date.now(),
      workerId,
      workerName: workerId ? workerName : '',
      tableId,
      tableName,
      clientName,
      clientId,
      discount,
      items,
      closed: false,
      paid: null,
      paidTime: 0,
      status,
      delivery: delivery || null,
      type,
      selfOrderPointId: selfOrderPointId || null,
    });

    const orderLog: OrderLog = {
      time: Date.now(),
      workerId,
      workerName,
      type: 'open',
      state: {
        workerId,
        workerName: workerId ? workerName : '',
        tableId,
        tableName,
        clientName,
        clientId,
        discount,
        items,
        paid: null,
        status,
        delivery: delivery || null,
      },
    };

    batch.set<OrderLog>(`cafes/${cafeSlug}/orders/${id}/logs/${uniqid()}`, orderLog);

    await batch.commit();
  }
};
